import React from "react";
import Heading from "../../components/common/Typography/Heading";
import Paragraph from "../../components/common/Typography/Paragraph";
import {
  PUBLIC_ABOUT_COLUMN_GAP_CLASS,
  PUBLIC_HEADING_TO_BODY_CLASS,
  PUBLIC_HEADING_TO_CONTENT_CLASS,
  PUBLIC_SECTION_GAP_CLASS,
} from "../Public/shared/publicLayoutSpec";

const LeftText = ({ heading, text }) => {
  return (
    <>
      <div
        className={`flex flex-col lg:flex-row items-center tp-container-main mx-auto w-full ${PUBLIC_SECTION_GAP_CLASS} ${PUBLIC_ABOUT_COLUMN_GAP_CLASS}`}
      >
        <div
          className={`lg:my-auto order-2 lg:order-1 ${PUBLIC_HEADING_TO_CONTENT_CLASS} lg:mt-0`}
        >
          <div>
            <Heading variant={"h2"} className={"text-offblack"}>
              {heading}
            </Heading>
            <Paragraph variant={"MainParagraph"} className={PUBLIC_HEADING_TO_BODY_CLASS}>
              {text}
            </Paragraph>
          </div>
        </div>
        <div className="order-1 lg:order-2 h-auto w-full lg:w-1/2 aspect-square shrink-0">
          <img
            className="object-cover w-full h-full rounded-xl"
            src={require("../../assets/img/TradesPosterSpeciality/businesses.jpg")}
            alt="trade-poster"
          />
        </div>
      </div>
    </>
  );
};

export default LeftText;
